import { useNavigate } from "react-router-dom";
import { Icon } from "../icon/icon";
import { Pill } from "../pill";
import { GuestCard } from "./guestCard";

export const HostCard = ({
  user,
  role,
  roleVariation,
}: {
  user?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    _id?: string;
  };
  role: string;
  roleVariation: 'purple' | 'blue';
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between gap-2 text-sm font-bold text-grey-900">
      <GuestCard
        name={`${user?.firstName} ${user?.lastName}`}
        otherDetails={`${user?.email} ∙ ${user?.phoneNumber || "No phone number"}`}
        otherText={undefined}
        email={undefined}
        timeAgo={undefined}
        hideEmailOnMobile={false}
        guest={undefined}
        ticketColor={undefined}
      />

      <button
        type="button"
        className="flex w-fit items-center gap-2 text-base font-bold text-grey-700"
        onClick={() => navigate(`/users/${user?._id}`)}
      >
        <Pill text={role} variation={roleVariation} />
        <Icon
          svg="caret-down"
          width={20}
          height={20}
          className="-rotate-90 text-grey-400"
        />
      </button>
    </div>
  );
};
